import React, { useState, useEffect } from 'react';

// 惦记页 v1.1：样式全走App.css类（rmd-*），CSS变量随主题/暗色自动切。
// 锁在服务端执行——dead根本不下发，box只给日期。这里只管老实渲染。

function fmtHK(iso) {
  if (!iso) return '';
  var d = new Date(new Date(iso).getTime() + 8 * 3600000);
  return (d.getUTCMonth() + 1) + '月' + d.getUTCDate() + '日 ' + d.getUTCHours().toString().padStart(2, '0') + ':' + d.getUTCMinutes().toString().padStart(2, '0');
}

var statusText = { pending: '等着到点', snoozed: '被拖了一会', fired: '已经开过口', missed: '没赶上', cancelled: '撤掉了' };
var repeatText = { daily: '每天', monthly: '每月', yearly: '每年' };

function Reminders() {
  var _s1 = useState([]); var items = _s1[0], setItems = _s1[1];
  var _s2 = useState(true); var loading = _s2[0], setLoading = _s2[1];
  var _s3 = useState(null); var confirming = _s3[0], setConfirming = _s3[1];

  var load = function() {
    fetch('/api/reminders').then(function(r) { return r.json(); }).then(function(d) {
      setItems(Array.isArray(d) ? d : []);
      setLoading(false);
    }).catch(function() { setLoading(false); });
  };
  useEffect(function() { load(); }, []);

  var del = function(id) {
    if (confirming !== id) { setConfirming(id); return; }
    setConfirming(null);
    fetch('/api/reminders/' + id, { method: 'DELETE' }).then(function() { load(); });
  };

  var upcoming = items.filter(function(r) { return r.status === 'pending' || r.status === 'snoozed'; });
  var past = items.filter(function(r) { return r.status !== 'pending' && r.status !== 'snoozed' && r.status !== 'cancelled'; });

  var renderCard = function(r) {
    var isBox = r.locked === 'box' && (r.status === 'pending' || r.status === 'snoozed');
    var isSilas = r.owner === 'silas';
    return (
      <div key={r.id} className="rmd-card">
        <div className="rmd-card-main">
          <div className={'rmd-owner' + (isSilas ? ' silas' : '')}>
            {isSilas ? 'Silas' : '林晏'}{r.kind === 'silent' ? ' · 悄悄的' : ''}{r.repeat && r.repeat !== 'none' ? ' · ' + (repeatText[r.repeat] || r.repeat) : ''}
          </div>
          {isBox ? (
            <div className="rmd-box">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
              <span>他记着一件事 · {r.fire_date ? r.fire_date.substring(5).replace('-', '月') + '日' : ''}</span>
            </div>
          ) : (
            <div>
              <div className="rmd-title">{r.title}</div>
              <div className="rmd-meta">{fmtHK(r.fire_at)} · {statusText[r.status] || r.status}</div>
            </div>
          )}
        </div>
        <button className={'rmd-del' + (confirming === r.id ? ' confirming' : '')} onClick={function() { del(r.id); }}>
          {confirming === r.id ? '确认删' : '删'}
        </button>
      </div>
    );
  };

  return (
    <div className="toybox-page">
      <div className="toybox-header">
        <button className="toybox-back" onClick={function() { window.history.back(); }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <div className="toybox-title">惦记</div>
        <div style={{ width: 36 }} />
      </div>
      <div className="rmd-body">
        {loading ? (
          <div className="rmd-empty">翻他的本子…</div>
        ) : items.length === 0 ? (
          <div className="rmd-empty">他还什么都没惦记上。<br/>跟他说一句带时间的话试试。</div>
        ) : (
          <div>
            {upcoming.length > 0 && <div className="rmd-section-label">还没到点的</div>}
            {upcoming.map(renderCard)}
            {past.length > 0 && <div className="rmd-section-label">已经响过的</div>}
            {past.map(renderCard)}
          </div>
        )}
      </div>
    </div>
  );
}

export default Reminders;
